import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

// Fetch chadawa bookings with pagination and filters
export const getChadawasBookingList = async (params = {}) => {
  try {
    // Build query string from params
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.search) queryParams.append('search', params.search);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);

    const queryString = queryParams.toString();
    const endpoint = queryString 
      ? `${API_URL}/chadawa/getAllChadawaTransactions?${queryString}` 
      : `${API_URL}/chadawa`;
    
    const response = await api.get(endpoint);
    return response.data;
  } catch (error) {
    console.error('API Error in getChadawasBookingList:', error);
    handleUnauthorizedOrForbidden(error);
    
    // Re-throw the error so Redux can handle it properly
    throw error.response?.data || error.message || 'Failed to fetch chadawa bookings';
  }
};

// Update chadawa booking date and time
export const updateChadawaBookingList = async (id, updateData) => {
  try {
    const response = await api.put(
      `${API_URL}/chadawa/getAllChadawaTransactions/${id}`, 
      updateData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('API Error in updateChadawaBookingList:', error);
    handleUnauthorizedOrForbidden(error);
    
    // Re-throw the error so Redux can handle it properly
    throw error.response?.data || error.message || 'Failed to update chadawa booking';
  }
};

// Update chadawa booking status
export const updateChadawaBookingListStatus = async (id, updateStatusObj) => {
  try {
    const response = await api.put(
      `${API_URL}/chadawa/getAllChadawaTransactions/${id}/status`, 
      updateStatusObj,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('API Error in updateChadawaBookingListStatus:', error);
    handleUnauthorizedOrForbidden(error);
    
    // Re-throw the error so Redux can handle it properly
    throw error.response?.data || error.message || 'Failed to update chadawa booking status';
  }
};